// extracted by mini-css-extract-plugin
export default {"container":"style__container___wm7JW","image":"style__image___HOe6_","doneControlsContainer":"style__doneControlsContainer___oYwEm","doneControls":"style__doneControls___Ci1Kg"};